export default __webpack_public_path__ + "static/media/explosion.38078243.mp3";